// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RewardDetailsTableRecord_wrapper__bCi58","wrapper__header":"RewardDetailsTableRecord_wrapper__header__JfeXj"};